import { createStyles } from '@material-ui/core';
export default (function () {
  return createStyles({
    container: {
      minWidth: 900,
      height: '75vh'
    },
    doc: {
      height: '100%',
      width: '100%'
    },
    pre: {
      display: 'block',
      padding: 9.5,
      margin: '0 0 10px',
      fontSize: 13,
      lineHeight: 1.428571429,
      color: '#333',
      wordBreak: 'break-all',
      wordWrap: 'break-word',
      backgroundColor: '#f5f5f5',
      border: '1px solid #ccc',
      borderRadius: 4,
      whiteSpace: 'pre-wrap'
    }
  });
});